import type { ReactNode } from "react";

import { InfoTipHint } from "./InfoTipHint";
import { m } from "./paraglide/messages";

interface PasteHintTipProps {
  hidden: boolean;
  children?: ReactNode;
  className?: string;
}

export function PasteHintTip(props: Readonly<PasteHintTipProps>) {
  const { hidden, children, className } = props;

  if (hidden) {
    return null;
  }

  return (
    <InfoTipHint label={m.paste_hint_tip()} className={className}>
      {children || (
        <>
          {m.paste_hint_message_before()}{" "}
          <kbd className="border-primary/40 bg-primary/20 rounded-lg border px-1.5 py-0.5 font-mono text-xs">
            Ctrl+V
          </kbd>{" "}
          {m.paste_hint_message_after()}
        </>
      )}
    </InfoTipHint>
  );
}
